import IconV2 from '@/components/v2/IconV2';
import clsx from '@/lib/clsx';

const WizardCard = ({ label, description, icon, selected = false, onClick, align = 'center', iconSize = 18, className = '', ...props }) => {
  const alignClass = align === 'left' ? 'align-left' : 'align-center';

  return (
    <div className={clsx('comp-wizard-card', alignClass, selected && 'selected', className)} onClick={onClick} {...props}>
      <div className="comp-wizard-card-icon">{icon && <IconV2 icon={icon} size={iconSize} />}</div>
      <div className="comp-wizard-card-label">{label}</div>
      {description && <div className="comp-wizard-card-description">{description}</div>}
    </div>
  );
};

export default WizardCard;
